import fc from '@/firebaseConfig'

export default {
  namespaced: true,
  state: {
    loading: false,
    companyStatus: false,
  },
  mutations: {
    setCompanyStatus(state, val) {
      state.companyStatus = val
    },
    setLoading(state, val) {
      state.loading = val
    },
  },
  actions: {
    getStatus({commit}, {companyId}) {
      fc.db.collection('Companies').doc(companyId)
        .collection('Statuses')
        .doc('payment')
        .get()
        .then(function (companyStatus) {
           if(companyStatus.data()){
              commit('setCompanyStatus', companyStatus.data().status)
           }
        })
        .catch(err => console.log(err))
    },
  },
}
